import { useContext, useEffect } from 'react'
import { AppContext, AppContextType } from '../../AppContext'
import ScreenShareSelectionPage from './ScreenShareSelectionPage'
import ElectronIPC from '../../services/ElectronIPC'
import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'

const windowName = 'ScreenShareSelectionModal'

export default function ScreenShareSelectionModalController() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    const onClose = () => {
        // close modal
        appDispatch({
            type: 'update_app_state',
            value: { showScreenShareSelectionPage: { isOpen: false } },
        })
    }

    useEffect(() => {
        // focus already-open modal.
        if (appState.appState.showScreenShareSelectionPage?.isOpen) {
            ElectronIPC.setWindowOptions({ windowName: windowName, triggerFocus: true })
        }
    }, [appState.appState.showScreenShareSelectionPage])

    if (appState.appState.showScreenShareSelectionPage?.isOpen) {
        return (
            <CrossPlatformDialog frameName={windowName} onDefaultClose={onClose}>
                <ScreenShareSelectionPage onClose={onClose} />
            </CrossPlatformDialog>
        )
    } else {
        return null
    }
}
